// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"uu-z","expressButtonContainerWithPayPal":"vu-z","expressButton":"wu-z","or":"xu-z"};